import PermissionHide from 'components/PermissionHide';
import Total from 'components/Total';
import React from 'react';
import { FormattedNumber } from 'react-intl';

const Items = (props: any) => (
  <div className={props.classes.items}>
    <div className='items__title'>
      <div className='title__item'>Itens da fatura</div>
      <div className='title__qnt'>Qtd.</div>
      <div className='title__coupon'>Cupom</div>
      <div className='title__unit'>Val. unit.</div>
      <div className='title__total'>Val. total</div>
    </div>

    <div className='items__content'>
      {props.items && props.items.isFetching
        ? 'Carregando ...'
        : props.items.length > 0
        ? props.items.map((item: any) => (
            <div className='items__row' key={'item-' + item.id}>
              <div className='row__description'>
                {item.description} ({item.id})
              </div>
              <div className='row__qnt'>{item.quantity}</div>
              <div className='row__coupon'>
                <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
                  <div>
                    <FormattedNumber value={item.discount ? item.discount : 0} format='BRL' />
                  </div>
                </PermissionHide>
                {item.coupon_key && <div style={{ paddingLeft: '5px' }}>({item.coupon_key})</div>}
              </div>
              <div className='row__unit'>
                <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
                  <FormattedNumber value={item.unit_value ? item.unit_value : 0} format='BRL' />
                </PermissionHide>
                <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
                  <em>oculto</em>
                </PermissionHide>
              </div>
              <div className='row__total'>
                <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
                  <FormattedNumber value={item.amount ? item.amount : 0} format='BRL' />
                </PermissionHide>
                <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
                  <em>oculto</em>
                </PermissionHide>
              </div>
            </div>
          ))
        : ''}
    </div>

    <div className='items__total'>
      <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
        <Total list={props.items} prop={'amount'} />
      </PermissionHide>
      <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
        <em>oculto</em>
      </PermissionHide>
    </div>
  </div>
);

export default Items;
